import ResourceService from './resource.service'

class BlanketOrderService extends ResourceService {
  static get resource() {
    return 'blanket-order'
  }

  static addBeneficiary(id, data) {
    return this.post(data, `${id}/add-beneficiary`)
  }

  static getEligibleBeneficiaries(id, params) {
    return this.get(`${id}/eligible-beneficiaries`, params)
  }

  // SFMS-1443 — validate the beneficiary to be replaced (not tied to a contract)
  static getBeneficiaryToReplace(beneficiary) {
    return this.get('beneficiary-to-replace', { beneficiary })
  }

  // SFMS-1443 — validate the new beneficiary against the old one
  static validateNewBeneficiary(oldBeneficiaryId, newBeneficiary) {
    return this.get('validate-new-beneficiary', { oldBeneficiaryId, newBeneficiary })
  }

  // SFMS-1443 — replace an existing beneficiary with a new one
  static replaceBeneficiary(data) {
    return this.post(data, 'replace-beneficiary')
  }
}

export default BlanketOrderService